import React from 'react';
import { contacts } from '../../config/contacts';

interface ContactInfoProps {
  showAddresses?: boolean;
  className?: string;
}

export default function ContactInfo({ showAddresses = true, className = '' }: ContactInfoProps) {
  const displayContacts = showAddresses 
    ? contacts 
    : contacts.filter(contact => contact.type !== 'Address');

  return (
    <div className={`space-y-4 ${className}`}>
      {displayContacts.map((contact, index) => {
        const Icon = contact.icon;
        return (
          <div key={`${contact.type}-${index}`} className="flex items-center">
            <Icon className="w-5 h-5 text-purple-600 mr-3" />
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">{contact.type}</p>
              {contact.href ? (
                <a 
                  href={contact.href}
                  className="text-gray-900 dark:text-white hover:text-purple-600 dark:hover:text-purple-400"
                >
                  {contact.value}
                </a>
              ) : (
                <p className="text-gray-900 dark:text-white">{contact.value}</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}